import { useState } from 'react';
import api from '../api/client';

export default function ImportModal({ onClose, onSuccess }) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleUpload = async () => {
    if (!file) return;
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const { data } = await api.post('/contacts/import', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setResult(data);
      if (onSuccess) onSuccess();
    } catch (err) {
      setResult({ error: err.response?.data?.error || 'Error al importar' });
    }
    setLoading(false);
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
    }}>
      <div style={{ background: '#fff', borderRadius: 8, padding: 30, maxWidth: 450, width: '90%' }}>
        <h3 style={{ marginTop: 0 }}>Importar contactos</h3>
        <p style={{ color: '#666', fontSize: 13 }}>
          Sube un archivo CSV o Excel con columnas: <strong>nombre</strong>, <strong>telefono</strong> (formato +521...), email (opcional)
        </p>
        <input
          type="file"
          accept=".csv,.xlsx,.xls"
          onChange={(e) => setFile(e.target.files[0])}
          style={{ marginBottom: 16, display: 'block' }}
        />
        {result && !result.error && (
          <div style={{ background: '#d4edda', padding: 10, borderRadius: 4, marginBottom: 12, fontSize: 13 }}>
            Creados: {result.created} | Actualizados: {result.updated} | Errores: {result.errors}
          </div>
        )}
        {result?.error && (
          <div style={{ background: '#f8d7da', padding: 10, borderRadius: 4, marginBottom: 12, fontSize: 13 }}>
            {result.error}
          </div>
        )}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{
            padding: '8px 20px', border: '1px solid #ddd', borderRadius: 4, background: '#fff', cursor: 'pointer',
          }}>Cerrar</button>
          <button onClick={handleUpload} disabled={!file || loading} style={{
            padding: '8px 20px', border: 'none', borderRadius: 4,
            background: '#4ecca3', color: '#fff', cursor: 'pointer',
            opacity: (!file || loading) ? 0.5 : 1,
          }}>
            {loading ? 'Importando...' : 'Importar'}
          </button>
        </div>
      </div>
    </div>
  );
}
